module.exports = __webpack_public_path__ + "img/9788901089591.0f0518bc.jpg";